import fetchServer from "../../../fetchServer";

export default async function setRefundFee(data) {
  var result = { return: 0, msg: "Failed setting refunding fee", data: [], code: null };

  await fetchServer({
    method: "POST",
    url: `/product/v1/refund/setRefundPrice`,
    data,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200) {
          result = { return: 1, msg: "Successfull", data: res.data.data, code: null };
        } else {
          const nested = res?.data?.data;
          const err =
            (typeof nested?.error === "string" && nested.error) ||
            (typeof res?.data?.error === "string" && res.data.error) ||
            (typeof res?.data?.message === "string" && res.data.message) ||
            result.msg;
          result.msg = err;
          result.code = nested?.code ?? res?.data?.code ?? null;
          result.data = nested || res?.data || [];
        }
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result["msg"] = "Network Error!";
        result["error"] = "Please check your connection.";
      }
    });

  return result;
}
